import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1d6befb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "crossX",
  class: "reticle-line-x"
}
const _hoisted_2 = {
  ref: "crossY",
  class: "reticle-line-y"
}
const _hoisted_3 = {
  ref: "boxEl",
  class: "reticle-box"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "reticle-box-inner" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  ref: "coordsEl",
  class: "reticle-coords"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.enabled)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["reticle", { 'reticle-armed': _ctx.reduced && !_ctx.tracking }]),
        "aria-hidden": "true"
      }, [
        _createElementVNode("span", _hoisted_1, null, 512),
        _createElementVNode("span", _hoisted_2, null, 512),
        _createElementVNode("span", _hoisted_3, _hoisted_5, 512),
        _createElementVNode("span", _hoisted_6, "X 0000 Y 0000 TRK", 512)
      ], 2))
    : _createCommentVNode("", true)
}